export default {
  navigation: {
    home: "Home",
    comfort: "Comfort",
    manage: "Beheren",
    profile: "Profiel"
  },
  general: {
    title: "Profiel",
    logout: "Uitloggen",
    app_version: "Appversie",
    edit: "Bewerken",
    view: "Bekijken",
    upload: "Uploaden",
    personal_details: {
      title: "Persoonlijke gegevens",
      email: "E-mail",
      phone: "Telefoon",
      address: "Adres",
      not_available: "Niet beschikbaar",
      guest_since: "Gast sinds :year",
      guest_since_unknown: "Gast"
    },
    documents: {
      title: "Paspoort en documenten",
      passport: "Paspoort",
      invoice: "Factuur",
      other_documents: "Documenten",
      available: "Beschikbaar",
      passport_available: "Beschikbaar",
      not_uploaded: "Niet geüpload",
      info: "Documenten kunnen vereist zijn voor de check-inverificatie"
    },
    preferences: {
      title: "Voorkeuren",
      language: "Taal",
      language_description: "Kies je voorkeurstaal"
    }
  }
};
